import { App } from 'vue';
import { Router } from 'vue-router';
import { BaseApplication } from './application.base';
import { ApplicationSpec } from './schemas';
import * as filters from './filters';
import * as _ from 'lodash-es';
import { getRouter } from './routes';
import debug from 'debug';
import { initializeErrorModalOptionsHookHandler } from './errors';

const log = debug('itp:core:application');

initializeErrorModalOptionsHookHandler();

export class Application extends BaseApplication {
  private vueApp: App | null = null;
  public router: Router | null = null;

  constructor(app: ApplicationSpec) {
    super(app);
  }

  install(app: App, router?: Router) {
    this.vueApp = app;
    log('Installing core application into Vue 3 instance');

    app.config.globalProperties.$app = this;
    app.config.globalProperties.$appContext = this;
    app.config.globalProperties.$config = this.config;
    app.config.globalProperties.$fn = this.fn;
    app.config.globalProperties.$i18n = this.i18n;
    app.config.globalProperties.$store = this.objectStore;
    app.config.globalProperties._ = _;

    app.config.globalProperties.$filters = {
      ...filters,
      ...this.i18n.filters,
      ...this.users.filters,
    };

    if (router) {
      log('Using provided custom router');
      this.router = router;
      app.use(router);
    } else {
      log('Creating default core router');
      const defaultRouter = getRouter(this.spec.home, app);
      this.router = defaultRouter;
      app.use(defaultRouter);
    }

    app.config.errorHandler = (error) => {
      console.error('[Core Error Handler]', error);
      this.events.emit('app:unhandledError', { error });
    };

    this.initializeServices();
  }

  async initializeServices() {
    try {
      await this.auth.init();
      await this.connections.initialize(this.spec.connections);
      await this.users.load();
      this.setReady();
    } catch (err) {
      log('initializeServices error:', err);
      this.setReady();
    }
  }

  mount(selector: string) {
    log('Core Application mounted (via host app)');
  }
}
